import { Component } from '@angular/core';
import { ClerkNocService } from '../service/clerk-noc.service';
import { session } from 'src/environments/environment.session';
import Swal from 'sweetalert2';
import { tick } from '@angular/core/testing';
import { Router } from '@angular/router';
// import * as pdfObjectImport  from 'pdfobject';
declare var PDFObject: any
import { NgxSpinnerService } from 'ngx-spinner';
import { MainService as mainService_MD } from '../../md/service/main.service'
import { LogService } from 'src/app/portal/service/log.service';
import { AllEmpService } from 'src/app/hrms/service/all-emp.service';


@Component({
  selector: 'app-noc-view',
  templateUrl: './noc-view.component.html',
  styleUrls: ['./noc-view.component.css']
})
export class NocViewComponent {
  ebillUser: any;
  b_acct_id: any;
  role: any = []
  constructor(private allEmpService: AllEmpService,private log: LogService, private mainServiceMD: mainService_MD, public clerknocservice: ClerkNocService, public spinner: NgxSpinnerService, public router: Router) { }
  async ngOnInit() {

    // this.role=[]
    this.ebillUser = JSON.parse(atob(session.erpUser));
    this.b_acct_id = this.ebillUser.b_acct_id;
    this.role = this.ebillUser.role_cd
    console.log(this.role)
    await this.getallworkflowuser()
    await this.getAllUsersInfo()

    console.log(this.ebillUser.role_cd)

    for (let i = 0; i < this.ebillUser.role_cd.length; i++) {
      if (this.ebillUser.role_cd[i] == 'CRK') {
        this.role = this.ebillUser.role_cd[i]

      } else if (this.ebillUser.role_cd[i] == 'CTP') {
        this.role = this.ebillUser.role_cd[i]

      }

      else if (this.role_cdArr.includes(this.ebillUser.role_cd[i])) {
        // Set the flags and other variables

        this.role = this.ebillUser.role_cd[i];
        console.log(this.role);


        // break; // Exit the loop if a matching role is found
      }
      // }
    }
    // await this.getallworkflowuser()
    await this.get_all_file();
    await this.get_all_notesheet();
    await this.adding_document()
    // await this.suppor_doc();
  }
  //////////////////////////////////////////////
  file_details: any = {}
  async get_all_file() {
    let obj: any = {};
    obj['b_acct_id'] = this.b_acct_id;
    obj['file_id'] = this.clerknocservice.file_id
    let resp = await this.clerknocservice.get_file_details(JSON.stringify(obj));
    if (resp['error'] == false) {
      console.log(resp);
      this.file_details = resp['data'][0];
    } else {
      Swal.fire('error', 'server side error', 'error');
      return
    }
  }


  // /////////////////////////////////////////////////////////////////////////////




  role_cdArr: any = []
  AllWorkFlow_Data: any = []
  async getallworkflowuser() {
    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id
    obj["doc_type"] = ['TAX', 'PROPERTY', 'ENGINEERING']
    obj["module_cd"] = 'NOC'
    obj["role"] = this.role
    obj["status"] = 'ACTIVE'

    let resp = await this.clerknocservice.getallworkflowuser(JSON.stringify(obj))
    console.log(resp)
    if (resp["error"] == false) {
      this.role_cdArr = []
      this.AllWorkFlow_Data = []
      this.AllWorkFlow_Data = resp.data
      this.role_cdArr = resp.data.map((item: { role_cd: any; }) => item.role_cd)
      console.log(this.AllWorkFlow_Data);

    }
  }




  // ///////////////////////////////////////
  notesheet_desc: any = []
  async get_all_notesheet() {

    console.log(this.AllWorkFlow_Data, "lllkkkkoo");
    console.log(this.role, "roleee");
    let arr :any ;
    if(['CTP','AMC'].includes(this.role)){
      arr = this.AllWorkFlow_Data
    }else if(['SDM'].includes(this.role)){
      arr  = this.AllWorkFlow_Data.filter((item: any) => item.doc_type == 'PROPERTY');
    }else if(['"EE_ENG_DEPT"'].includes(this.role)){
      arr  = this.AllWorkFlow_Data.filter((item: any) => item.doc_type == 'ENGINEERING');
    }
    else if(['ZO'].includes(this.role)){
      arr  = this.AllWorkFlow_Data.filter((item: any) => item.doc_type == 'TAX');
    }
    else{
      arr  = this.AllWorkFlow_Data.filter((item: any) => item.role_cd == this.role);
    }
    console.log(arr);
    let alluperrole = []
    if (arr.length > 0) {
      const [{ level: targetLevel }] = arr;

      let secondarray = this.AllWorkFlow_Data.filter((item: any) =>
        arr.some((departmentObj: any) => departmentObj.doc_type === item.doc_type)
      );
      console.log(secondarray);
      let finalarr:any;
      if(!['SDM','EE_ENG_DEPT','ZO','CTP','AMC'].includes(this.role)){
        finalarr = secondarray.filter((item: any) => item.level <= targetLevel);
      }else{
        finalarr = secondarray
      }
      console.log(finalarr);
      alluperrole = finalarr.map((item: any) => item.role_cd)

    } else {
      console.log("No matching role_cd found in AllWorkFlow_Data");
    }






    let obj: any = {};
    obj['b_acct_id'] = this.b_acct_id;
    obj['file_id'] = this.clerknocservice.file_id
    obj["role"] = ['CTP', 'CRK', ...alluperrole]
    console.log(obj);


    let resp = await this.clerknocservice.getfiledatabyfileid(obj)
    console.log(resp)
    if (resp["error"] == false) {


      this.supp_doc = resp['file_supp_doc']


      resp['file_notesheet'].map((x: any) => {
        this.notesheet_desc.push({
          'desc': JSON.parse(x.description),
          'notesheet_id': x.notesheet_id,
          'role': x.create_role,
          'user_id': x.user_id,
          'file_id': x.file_id,
          'lang': x.lang
        });
      })
    }







    // }

    // let resp = await this.clerknocservice.get_all_notesheet(JSON.stringify(obj));
    // console.log(resp)
    // if (resp['error'] == false) {
    //   resp['data'].map((x: any) => {
    //     this.notesheet_desc.push({
    //       'desc': JSON.parse(x.description),
    //       'notesheet_id': x.notesheet_id,
    //       'role': x.create_role,
    //       'user_id': x.user_id,
    //       'file_id': x.file_id
    //     });
    //   })
    //   console.log(this.notesheet_desc)
    //   return
    // } else {
    //   Swal.fire('error', 'server side error', 'error');
    //   return
    // }
  }


  //////////////////////////

  allEmplyees_new: any = []
  allEmployees: any = []
  allSearchableEmp: any = []
  userObj: any = {}
  logObj = { component: 'NOC View' }

  async getAllEmployees() {
    console.log('all emp')
    this.spinner.show()
    var arr: any = []
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['module_cd'] = 'NOC'
    var resp = await this.mainServiceMD.getuserformodulerolemapping(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "User for Module Role Mapping Received Successfully " })
      this.spinner.hide()
      arr = resp.data;
      console.log(resp, 'users')
      for (let i = 0; i < arr.length; i++) {
        this.userObj[arr[i]['user_id']] = arr[i]
        arr[i]['desc'] = arr[i]['user_id'] + " - " + arr[i]['emp_name'] + " - " + arr[i]['emp_phone_no']
      }
      this.allSearchableEmp = arr

    } else {
      this.spinner.hide()
    }
    console.log(this.allEmployees, this.allEmplyees_new, 'employees')
  }
  allUser: any = [];
  UserObj: any = {};
  async getAllUsersInfo() {
    var obj: any = {};
    obj["b_acct_id"] = this.b_acct_id
    var resp = await this.allEmpService.getAllPartyFields(JSON.stringify(obj));
    // var resp = await this.userAdd.getAllUsersInfo(JSON.stringify(obj));
    console.log(resp);
    if (resp['error'] == false) {
      this.allUser = resp['data'];
      for (let i = 0; i < this.allUser.length; i++) {
        this.UserObj[this.allUser[i]['le_id']] = this.allUser[i]['emp_name']
        this.allUser[i]['name'] = this.allUser[i]['emp_name']
      }
      console.log(this.UserObj)
    } else {

    }
  }

  // ////////////////////////////////
  back() {
    this.router.navigate([this.clerknocservice.URL]);
  }
  ////////////////////////////////////
  supp_doc: any = []
  async suppor_doc() {
    let obj: any = {};
    obj['b_acct_id'] = this.b_acct_id;
    obj['file_id'] = this.clerknocservice.file_id
    let resp = await this.clerknocservice.supporting_doc(JSON.stringify(obj));
    console.log(resp)
    if (resp['error'] == false) {
      this.supp_doc = resp['data']
      // for(let i = 0 ; i < this.notesheet_desc.length ; i++){
      //   this.notesheet_desc[i]['supp_doc'] = []
      //   for(let j = 0 ; j < this.supp_doc.length ; j++){
      //     if(this.notesheet_desc[i]['notesheet_id'] === this.supp_doc[j]['notesheet_id']){
      //           this.notesheet_desc[i]['supp_doc'].push(this.supp_doc[j]);
      //     }
      //   }
      // }
      console.log(this.supp_doc)
    } else {
      Swal.fire('error', 'server side error', 'error');
      return
    }
  }


   ////////////////////////////////////
   adding_doc: any = []
   async adding_document() {
     let obj: any = {};
     obj['b_acct_id'] = this.b_acct_id;
     obj['file_id'] = this.clerknocservice.file_id
     let resp = await this.clerknocservice.adding_document(JSON.stringify(obj));
     console.log(resp)
     if (resp['error'] == false) {
      this.adding_doc=[]
       this.adding_doc = resp['data']
       // for(let i = 0 ; i < this.notesheet_desc.length ; i++){
       //   this.notesheet_desc[i]['supp_doc'] = []
       //   for(let j = 0 ; j < this.supp_doc.length ; j++){
       //     if(this.notesheet_desc[i]['notesheet_id'] === this.supp_doc[j]['notesheet_id']){
       //           this.notesheet_desc[i]['supp_doc'].push(this.supp_doc[j]);
       //     }
       //   }
       // }
       console.log(this.adding_doc)
     } else {
       Swal.fire('error', 'server side error', 'error');
       return
     }
   }

  // ////////////////////////////////////////////////////////////////////////
  fileURL: any
  async view_correspondence(correspondence_no: any) {
    console.log(correspondence_no)
    let obj: any = {}
    obj['b_acct_id'] = this.b_acct_id
    obj['doc_name'] = correspondence_no
    obj['file_id'] = this.clerknocservice.file_id
    var res = await this.clerknocservice.viewCorrespondence(obj)

    if (res) {
      let file = new Blob([res], { type: 'application/pdf' });
      this.fileURL = URL.createObjectURL(file);
      // console.log(fileURL)
      window.open(this.fileURL)
      // PDFObject.embed(this.fileURL, '#pdf')
    } else {

    }


  }
}
